import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PermissionGateway from "../components/permission/PermissionGateway";
import {
  Activitysidebar,
  ClientIcon,
  Conferencesidebar,
  Dashboardsidebar,
  Deliverablesidebar,
  EAppsicon,
  Employeesidebar,
  GeneralIcon,
  ProductionIcon,
  ProjectIdentification,
  Projectsidebar,
  ReportIcon,
  ResourcingIcon,
  Settingsidebar,
  Subprojectsidebar,
  Tasksidebar,
  Trashsidebar,
} from "../assets/svgicons";
import { useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import RecursiveMenuPopover from "./recursive-menu-popover";
import { menuData } from "./menu-item-config";

const Sidebar = () => {
  const location = useLocation()?.pathname;
  // Active Class

  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuItems, setSubmenuItems] = useState([]);

  const handleItemHover = (event, item) => {
    if (item.children) {
      setSubmenuItems(item.children);
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubmenuItems([]);
  };

  //responsive
  const isMobile = useMediaQuery("(max-width:991px)");

  const active = (navTab) => {
    let classtring = "";
    switch (navTab) {
      case "/dashboard":
        if (location.includes("/dashboard")) {
          classtring = "active";
        }
        break;
      case "/eapps":
        if (location.includes("/eapps")) {
          classtring = "active";
        }
        break;
      case "/employees":
        if (
          location.split("/")[1].includes("employees")

          // location.includes('/employees/active') ||
          // location.includes('/employees/inactive') ||
          // location.includes('/employees/draft') ||
          // location.includes('/employees/add') ||
          // location.includes('/employees/edit') ||
          // location.includes('/employees/details/')
          // location.includes('/employee-exit')
        ) {
          classtring = "active";
        }
        break;
      case "/hr-settings":
        if (
          location.split("/")[1].includes("hr-settings") ||
          location.includes("/add-user-access-level") ||
          location.includes("/view-user-access-level/") ||
          // location.includes('/add-user-access-level') ||
          location.includes("/edit-user-access-level/") ||
          location.includes("/clone-user-access-level/")
          // location.includes('/hr-settings/employee-exit-approvals')
        ) {
          classtring = "active";
        }
        break;
      case "/sales-settings":
        if (location.includes("/sales-settings")) {
          classtring = "active";
        }
        break;
      case "/developer-settings":
        if (location.includes("/developer-settings")) {
          classtring = "active";
        }
        break;
      case "/emanage-settings":
        if (location.includes("/emanage-settings")) {
          classtring = "active";
        }
        break;
      case "/production-settings":
        if (location.includes("/production-settings")) {
          classtring = "active";
        }
        break;
      case "/organisations":
        if (
          location.split("/")[1].includes("organisations")
          // ||
          // location.includes('/organisations/add') ||
          // location.includes('/organisations/edit') ||
          // location.includes('/organisation') ||
          // location.includes('/organisations/contacts/') ||
          // location.includes('/organisations/tasks/')
        ) {
          classtring = "active";
        }
        break;
      case "/contacts":
        if (
          location.split("/")[1].includes("contacts")
          // location.includes('/contacts') ||
          // location.includes('/contacts/add') ||
          // location.includes('/contacts/edit')
        ) {
          classtring = "active";
        }
        break;
      // case '/tasks':
      //   if (
      //     location.split('/')[1].includes('tasks')
      //     // location.includes('/tasks') ||
      //     // location.includes('/tasks/add') ||
      //     // location.includes('/tasks/edit')
      //   ) {
      //     classtring = 'active';
      //   }
      //   break;

      case "/production":
        if (
          location.split("/")[1] === "projects" ||
          location.split("/")[1] === "sub-projects" ||
          location.split("/")[1] === "activity-files" ||
          location.split("/")[1] === "deliverables" ||
          location.split("/")[1] === "project-queries" ||
          location.split("/")[1] === "variation-orders" ||
          location.split("/")[1] === "timesheets" ||
          location.split("/")[1] === "project-identification"
        ) {
          classtring = "active";
        }
        break;

      case "/report":
        if (
          location.split("/")[1] === "reports" ||
          location.split("/")[1] === "skill-reports" ||
          location.split("/")[1] === "analytical-reports"
        ) {
          classtring = "active";
        }
        break;

      case "/client":
        if (
          location.split("/")[1] === "clients" ||
          location.split("/")[1] === "contacts" ||
          location.split("/")[1] === "checklist" ||
          location.split("/")[1] === "feedback" ||
          location.split("/")[1] === "meeting-notes" ||
          location.split("/")[1] === "prs"
        ) {
          classtring = "active";
        }
        break;

      case "/resourcing":
        if (
          location.split("/")[1] === "resource-planner" ||
          location.split("/")[1] === "eskills" ||
          location.split("/")[1] === "team-chart"
        ) {
          classtring = "active";
        }
        break;

      case "/general":
        if (
          location.split("/")[1] === "task-reminders" ||
          location.split("/")[1] === "trash"
        ) {
          classtring = "active";
        }
        break;

      case "/settings":
        if (
          location.split("/")[1] === "developer-settings" ||
          location.split("/")[1] === "emanage-settings"
        ) {
          classtring = "active";
        }
        break;

      case "/projects":
        if (
          location.split("/")[1] === "projects"

          // location.includes('/projects')  ||
          // location.includes('/projects/create') ||
          // location.includes('/project-unarchive/') ||
          // location.includes('/post-implementation-review/') ||
          // location.includes('/projects/contacts/') ||
          // location.includes('/projects/project-queries/')
        ) {
          classtring = "active";
        }
        break;
      case "/clients":
        if (
          location.split("/")[1] === "clients"
          // location.includes('/checklist/details')
          // location.includes('clients') ||
          // location.includes('/client-overview/') ||
          // location.includes('/contracts') ||
          // location.includes('/contracts/add') ||
          // location.includes('/contracts/edit')
        ) {
          classtring = "active";
        }
        break;
      case "/checklist":
        if (
          location.split("/")[1] === "checklist" ||
          location.includes("/checklist/details")
          // location.includes('clients') ||
          // location.includes('/client-overview/') ||
          // location.includes('/contracts') ||
          // location.includes('/contracts/add') ||
          // location.includes('/contracts/edit')
        ) {
          classtring = "active";
        }
        break;
      case "/sub-projects":
        if (
          location.split("/")[1] === "sub-projects" ||
          location.includes("/post-implementation-review/")
          // ||
          // location.includes('/sub-project/add') ||
          // location.includes('/sub-projects') ||
          // location.includes('/sub-projects/edit') ||
          // location.includes('/sub-projects/variation-orders/')
        ) {
          classtring = "active";
        }
        break;
      case "/prs":
        if (
          location.split("/")[1] === "prs" ||
          location.includes("/prs")
        ) {
          classtring = "active";
        }
        break;

      case "/project-identification":
        if (
          location.split("/")[1] === "project-identification"
        ) {
          classtring = "active";
        }
        break;

      case "/activity-files":
        if (
          location.split("/")[1].includes("activity-files") ||
          location.includes("/qc2") ||
          // location.includes('/activity-files/add')
          location.split("/")[1].includes("activity-file")
        ) {
          classtring = "active";
        }
        break;
      case "/deliverables":
        if (location.includes("/deliverables")) {
          classtring = "active";
        }
        break;
      case "/timesheets":
        if (location.includes("/timesheets")) {
          classtring = "active";
        }
        break;
      case "/project-queries":
        if (
          location.split("/")[1].includes("project-queries") ||
          location.includes("/project-query-overview")

          // location.includes('/project-queries-by-sub-project') ||
          // location.includes('/project-query-overview') ||
          // location.includes('/raise-project-query') ||
          // location.includes('/project-queries')
        ) {
          classtring = "active";
        }
        break;
      case "/variation-orders":
        if (location.split("/")[1].includes("variation-orders")) {
          classtring = "active";
        }
        break;
      case "/conference":
        if (
          location.split("/")[1] === "conference" ||
          location.includes("/edit-conference/") ||
          location === "/add-conference" ||
          location.includes("/book-conference") ||
          location.includes("/view-conference/") ||
          location.includes("/edit-book-conference")
        ) {
          classtring = "active";
        }
        break;
      case "/trash":
        if (location.includes("trash")) {
          classtring = "active";
        }
        break;
      case "/reports":
        if (location.split("/")[1] === "reports") {
          classtring = "active";
        }
        break;
      case "/analytical-reports":
        if (location.split("/")[1] === "analytical-reports") {
          classtring = "active";
        }
        break;

      case "/reports-builder":
        if (
          location.split("/")[1] === "reports-builder" ||
          location.includes("/add-reports-builder") ||
          location.includes("/edit-reports-builder/")
        ) {
          classtring = "active";
        }
        break;

      case "/feedback":
        if (location.split("/")[1].includes("feedback")) {
          classtring = "active";
        }
        break;

      case "/meeting-notes":
        if (
          location.split("/")[1] === "meeting-notes" ||
          location.includes("/add-meeting-notes") ||
          location.includes("/edit-meeting-notes")
        ) {
          classtring = "active";
        }
        break;

      case "/skills/skill-planner":
        if (location.includes("/skills/skill-planner")) {
          classtring = "active";
        }
        break;

      case "/skills/skill-matrix":
        if (location.includes("/skills/skill-matrix")) {
          classtring = "active";
        }
        break;

      case "/resource-planner":
        if (
          location.split("/")[1] === "resource-planner" ||
          location.includes("/resource-planner-add") ||
          location.includes("/resource-planner-edit")
        ) {
          classtring = "active";
        }
        break;
      case "/team-chart":
        if (
          location.split("/")[1] === "team-chart"
        ) {
          classtring = "active";
        }
        break;

      case "/task-reminders":
        if (location.split("/")[1] === "task-reminders") {
          classtring = "active";
        }
        break;

      default:
        break;
    }

    return classtring;
  };

  const permissionsMatrix = useSelector(
    (state) => state.permissions.permissionsMatrix
  );

  const checkOverallPermissions = (moduleAliasArray) => {
    if (!permissionsMatrix?.length) return false;

    return permissionsMatrix.some(
      (perm) =>
        moduleAliasArray.includes(perm.permission.module.alias) && // matches target module
        perm.permission.alias.startsWith("view") && // only view permissions
        Number(perm.flag) === 1 // permission is actually enabled
    );
  };

  return (
    <>
      {/* <li class="nav-item sidebar-actions">
        <span class="nav-link">
          <div class="">
            <h6 class="font-weight-normal mb-1">Home</h6>
          </div>
        </span>
      </li> */}
      <div className="mt-2"></div>

      <li className={`nav-item nav-click ${active("/dashboard")}`}>
        <NavLink to="/dashboard" className={`nav-link`}>
          <i className="menu-icon">
            <Dashboardsidebar width={18} height={18} />
          </i>
          <span className="menu-title">Dashboard</span>
        </NavLink>
      </li>

      {!isMobile && (
        <li className={`nav-item nav-click ${active("/eapps")}`}>
          <NavLink to="/eapps" className={`nav-link`}>
            <i className="menu-icon">
              <EAppsicon width={18} height={18} />
            </i>
            <span className="menu-title">eApplications</span>
          </NavLink>
        </li>
      )}

      {checkOverallPermissions(["employees"]) && !isMobile && (
        <>
          <li className={`nav-item nav-click ${active("/employees")}`}>
            <PermissionGateway
              moduleAlias={"employees"}
              permissionAlias={"view"}
            >
              <Link className="nav-link" to="/employees/active">
                <i className="menu-icon">
                  <Employeesidebar width={18} height={18} />
                </i>
                <span className="menu-title">Employees</span>
              </Link>
            </PermissionGateway>
          </li>
        </>
      )}

      <li className={`nav-item nav-click ${active("/conference")}`}>
        <PermissionGateway moduleAlias={"conference"} permissionAlias={"view"}>
          <Link className="nav-link" to="/conference/calender-view">
            <i className="menu-icon">
              <Conferencesidebar width={18} height={18} />
            </i>
            <span className="menu-title">Conference</span>
          </Link>
        </PermissionGateway>
      </li>

      {/* <li className={`nav-item nav-click ${active("/project-identification")}`}>
        <PermissionGateway moduleAlias={"project-identification"} permissionAlias={"view"}>
          <Link className="nav-link" to="/project-identification/identification">
            <i className="menu-icon">
              <ProjectIdentification width={18} height={18} />
            </i>
            <span className="menu-title">Projects Identification</span>
          </Link>
        </PermissionGateway>
      </li> */}

      {checkOverallPermissions([
        "projects",
        "sub_projects",
        "activity_files",
        "pqs",
        // "clients",
        "timesheets",
        "project-identification"
        // "contacts",
      ]) && (
          <>
            {/* {!isMobile && <div class="border-bottom"></div>} */}
            {!isMobile ? (
              menuData
                .filter((item) => item.label === "Production")
                .map((item, index) => (
                  <li
                    className={`nav-item pr-1 pointer ${active("/production")}`}
                    key={index}
                    onClick={(e) => handleItemHover(e, item)}
                  >
                    <Link className="nav-link">
                      <i className="menu-icon">
                        <ProductionIcon width={18} height={18} />
                      </i>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <span className="menu-title">{item.label}</span>
                        <span className="menu-title">
                          <ChevronRightIcon
                            sx={{ width: 18, height: 18, color: active("/production") === "active" ? "#fff" : "#B40607" }}
                          />
                        </span>
                      </div>
                    </Link>
                  </li>
                ))
            ) : (
              <>
                <li class="nav-item sidebar-actions">
                  <span class="nav-link">
                    <div class="">
                      <h6 class="font-weight-normal mb-1">Production</h6>
                    </div>
                  </span>
                </li>

                <li className={`nav-item nav-click ${active("/projects")}`}>
                  <PermissionGateway
                    moduleAlias={"projects"}
                    permissionAlias={"view"}
                  >
                    <Link className="nav-link" to="/projects/onboarding">
                      <i className="menu-icon">
                        <Projectsidebar width={18} height={18} />
                      </i>
                      <span className="menu-title">Projects</span>
                    </Link>
                  </PermissionGateway>
                </li>

                <li className={`nav-item nav-click ${active("/sub-projects")}`}>
                  <PermissionGateway
                    moduleAlias={"sub_projects"}
                    permissionAlias={"view"}
                  >
                    <Link
                      className="nav-link"
                      to="/sub-projects/work-in-progress"
                    >
                      <i className="menu-icon">
                        <Subprojectsidebar width={18} height={18} />
                      </i>
                      <span className="menu-title">Sub-Projects</span>
                    </Link>
                  </PermissionGateway>
                </li>

                <li
                  className={`nav-item nav-click ${active("/activity-files")}`}
                >
                  <PermissionGateway
                    moduleAlias={"activity_files"}
                    permissionAlias={"view"}
                  >
                    <Link className="nav-link" to="/activity-files/not-started">
                      <i className="menu-icon">
                        <Activitysidebar width={18} height={18} />
                      </i>
                      <span className="menu-title">Activity/Files</span>
                    </Link>
                  </PermissionGateway>
                </li>

                <li className={`nav-item nav-click ${active("/deliverables")}`}>
                  <PermissionGateway
                    moduleAlias={"deliverables"}
                    permissionAlias={"view"}
                  >
                    <Link className="nav-link" to="/deliverables/overdue">
                      <i className="menu-icon">
                        <Deliverablesidebar width={18} height={18} />
                      </i>
                      <span className="menu-title">Deliverables</span>
                    </Link>
                  </PermissionGateway>
                </li>
              </>
            )}
          </>
        )}

      {checkOverallPermissions(["reports"]) && (
        <>
          {!isMobile &&
            menuData
              .filter((item) => item.label === "Report")
              .map((item, index) => (
                <li
                  className={`nav-item pr-1 pointer ${active("/report")}`}
                  key={index}
                  onClick={(e) => handleItemHover(e, item)}
                >
                  <Link className="nav-link">
                    <i className="menu-icon">
                      <ReportIcon width={18} height={18} />
                    </i>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="menu-title">{item.label}</span>
                      <span className="menu-title">
                        <ChevronRightIcon
                          sx={{ width: 18, height: 18, color: active("/report") === "active" ? "#fff" : "#B40607" }}
                        />
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
        </>
      )}

      {/* {!isMobile && <div class="border-bottom"></div>} */}

      {checkOverallPermissions(["clients", "contacts"]) && (
        <>
          {!isMobile &&
            menuData
              .filter((item) => item.label === "Client")
              .map((item, index) => (
                <li
                  className={`nav-item  pr-1 pointer ${active("/client")}`}
                  key={index}
                  onClick={(e) => handleItemHover(e, item)}
                >
                  <Link className="nav-link">
                    <i className="menu-icon">
                      <ClientIcon width={18} height={18} />
                    </i>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="menu-title">{item.label}</span>
                      <span className="menu-title">
                        <ChevronRightIcon
                          sx={{ width: 18, height: 18, color: active("/client") === "active" ? "#fff" : "#B40607" }}
                        />
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
        </>
      )}

      {/* {!isMobile && <div class="border-bottom"></div>} */}

      {checkOverallPermissions(["resource_planner"]) && (
        <>
          {!isMobile &&
            menuData
              .filter((item) => item.label === "Resourcing")
              .map((item, index) => (
                <li
                  className={`nav-item  pr-1 pointer ${active("/resourcing")}`}
                  key={index}
                  onClick={(e) => handleItemHover(e, item)}
                >
                  <Link className="nav-link">
                    <i className="menu-icon">
                      <ResourcingIcon width={18} height={18} />
                    </i>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="menu-title">{item.label}</span>
                      <span className="menu-title">
                        <ChevronRightIcon
                          sx={{ width: 18, height: 18, color: active("/resourcing") === "active" ? "#fff" : "#B40607" }}
                        />
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
        </>
      )}

      {/* {!isMobile && <div class="border-bottom"></div>} */}
      {checkOverallPermissions(["task_reminder", "trash", "conference"]) && (
        <>
          {!isMobile ? (
            menuData
              .filter((item) => item.label === "General")
              .map((item, index) => (
                <li
                  className={`nav-item  pr-1 pointer ${active("/general")}`}
                  key={index}
                  onClick={(e) => handleItemHover(e, item)}
                >
                  <Link className="nav-link">
                    <i className="menu-icon">
                      <GeneralIcon width={18} height={18} />
                    </i>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="menu-title">{item.label}</span>
                      <span className="menu-title">
                        <ChevronRightIcon
                          sx={{ width: 18, height: 18, color: active("/general") === "active" ? "#fff" : "#B40607" }}
                        />
                      </span>
                    </div>
                  </Link>
                </li>
              ))
          ) : (
            <>
              <li class="nav-item sidebar-actions">
                <span class="nav-link">
                  <div class="">
                    <h6 class="font-weight-normal mb-1">General</h6>
                  </div>
                </span>
              </li>
              {!isMobile && (
                <li className={`nav-item nav-click ${active("/trash")}`}>
                  <PermissionGateway
                    moduleAlias={"trash"}
                    permissionAlias={"view"}
                  >
                    <Link className="nav-link" to="/trash/projects">
                      <i className="menu-icon">
                        <Trashsidebar width={18} height={18} />
                      </i>
                      <span className="menu-title">Trash</span>
                    </Link>
                  </PermissionGateway>
                </li>
              )}
              <li className={`nav-item nav-click ${active("/task-reminders")}`}>
                <PermissionGateway
                  moduleAlias={"task_reminder"}
                  permissionAlias={"view"}
                >
                  <Link className="nav-link" to="/task-reminders/allTask">
                    <i className="menu-icon">
                      <Tasksidebar width={18} height={18} />
                    </i>
                    <span className="menu-title">Task Reminder</span>
                  </Link>
                </PermissionGateway>
              </li>
            </>
          )}
        </>
      )}

      {checkOverallPermissions(["developer_settings", "emanage_settings"]) &&
        !isMobile && (
          <>
            {menuData
              .filter((item) => item.label === "Settings")
              .map((item, index) => (
                <li
                  className={`nav-item  pr-1 pointer ${active("/settings")}`}
                  key={index}
                  onClick={(e) => handleItemHover(e, item)}
                >
                  <Link className="nav-link">
                    <i className="menu-icon">
                      <Settingsidebar width={18} height={18} />
                    </i>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="menu-title">{item.label}</span>
                      <span className="menu-title">
                        <ChevronRightIcon
                          sx={{ width: 18, height: 18, color: active("/settings") === "active" ? "#fff" : "#B40607" }}
                        />
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
          </>
        )}
      <RecursiveMenuPopover
        items={submenuItems}
        anchorEl={anchorEl}
        onClose={handleClose}
        active={active}
      />
    </>
  );
};

export default Sidebar;
